export const EXAMPLES_EN = [
    'Create a workshop owner',
    'Create a contradictory person',
    'Create a club owner',
    'Create an accountant working for one of the big corporations.',
    'Create a street doc',
    'Create an office clerk',
    'Create a magic theorist',
    'Create an NPC who wants to become a runner someday',
    'Create an unsuccessful restaurant owner',
    'Create a smuggler who uses a bicycle',
    'Create a drug dealer',
    'Create a gang member',
    'Create a street musician',
    'Create a reporter',
    'Create a bartender',
    'Create an eco-terrorist',
    'Create an office clerk who would love to be an eco-terrorist',
    'Create an artificial intelligence',
    'Create an NPC from Hamburg',
    'Create a burnt-out mage',
    'Create a mage',
    'Create an anarchist',
    'Create a conspiracy theorist',
    'Create a corrupt cop',
    'Create a corrupt politician',
    'Create a board member of a large corporation',
    'Create a factory worker',
    'Create a runner',
    'Create a fence',
    'Create a babushka',
    'Create a dwarf',
    'Create a taxi driver',
    'Create a cultist',
    'Create an eccentric artifact collector',
    'Create a ferryman',
    'Create a bodyguard',
    'Create a bouncer',
    'Create a homeless person',
    'Create a troll',
    'Create an ork',
    'Create a security consultant',
    'Create a scientist working for one of the big corporations.',
    'Create an elf',
    'Create a freighter pilot',
    'Create a criminal hacker',
    'Create a private detective',
    'Create a paranormal researcher',
    'Create an NPC who is a retired shadowrunner',
    'Create a corporate spy',
    'Create a professional assassin',
    'Create an illegal arms dealer',
    'Create a mercenary',
    'Create a guerrilla fighter',
    'Create a civil rights activist',
    'Create a graffiti artist',
    'Create a paranormal creature hunter',
    'Create a war veteran',
    'Create a religious fanatic',
    'Create an NPC from Berlin',
    'Create a cybercriminal',
    'Create a doctor who secretly conducts experiments',
    'Create a criminal underworld boss',
    'Create a fugitive war criminal',
    'Create a private security guard',
    'Create a paranormal creature expert',
    'Create a famous rock star',
    'Create a wealthy philanthropist',
    'Create a schizophrenic matrix developer',
    'Create a magic teacher from the school of magic',
    'Create a sadistic gang leader',
    'Create a committed transhumanist',
    'Create a firefighter who is afraid of fire',
    'Create a peace ambassador who loves to start fights',
    'Create a highly educated fool',
    'Create a philosophical mercenary',
    'Create an enthusiastic pessimist',
    'Create an environmental activist who works for an oil company',
    'Create a cynical motivational speaker',
    'Create a wandering hermit',
    'Create a paranoid security consultant',
    'Create an architect with claustrophobia',
    'Create a shady lawyer',
    'Create a high-ranking military officer',
    'Create a drug-addicted artist',
    'Create a former runner who has become the law',
    'Create a pimp',
    'Create an undercover investigator',
    'Create a GreenWar activist',
    'Create a neighborhood watchman',
    'Create a discharged soldier',
    'Create a humanitarian shopkeeper',
    'Create a bartender with a criminal past',
    'Create a corporate spy',
    'Create a small megacorp informant',
    'Create a probation officer',
    'Create a drone dealer',
    'Create a cyberware engineer',
    'Create an informant who is only an informant because he has to pay off his debts.',
    'Create a scrap dealer',
    'Create a security employee',
    'Create an explosives expert',
    'Create a shady lawyer',
    'Create the operator of an illegal cybercafé',
    'Create a spy of a rival corporation',
]
